import React from "react";
import {
  FaMapMarkedAlt,
  FaArrowRight,
  FaCar,
  FaGlobeAsia,
} from "react-icons/fa";

const locations = [


  // {
  //   title: "Mumbai ↔ Pune",
  //   image: "/images/network/Mumbai--Pune---Mumbai.png",
  //   icon: <FaMapMarkedAlt />,
  //   desc:
  //     "Travel conveniently between Mumbai and Pune with flexible cab options suitable for families, devotees and business travellers.",
  //   link: "/Mumbai-to-Pune-Cab",
  // },
  {
    title: "Nashik",
    image: "/images/network/Nashik.png",
    icon: <FaMapMarkedAlt />,
    desc:
      "Make your Nashik journey convenient with well-maintained cabs, experienced drivers and flexible travel arrangements.",
    link: "/Mumbai-to-Nashik-Cab",
  },
  {
    title: "Goa",
    image: "/images/network/Goa.png",
    icon: <FaMapMarkedAlt />,
    desc:
      "Enjoy a relaxed long-distance journey to Goa with spacious vehicles and experienced chauffeurs for a comfortable trip.",
    link: "/Mumbai-to-Goa-Cabs",
  },

  {
    title: "Kolhapur",
    image: "/images/network/kolhapur.png",
    icon: <FaMapMarkedAlt />,
    desc:
      "Choose Sai Shirdi Cabs for a smooth Kolhapur journey with convenient pickup, comfortable vehicles and dependable travel support.",
    link: "/Mumbai-to-Kolhapur-Cab",
  },



  {
    title: "Pune",
    image: "/images/network/Pune.png",
    icon: <FaMapMarkedAlt />,
    desc:
      "Book a comfortable Pune cab for family travel, pilgrimage journeys, airport connections and convenient outstation trips.",
    link: "/Mumbai-to-Pune-Cab",
  },
    {
    title: "Mumbai Outstation Cabs",
    image: "/images/network/mumbai-outstation.png",
    icon: <FaCar />,
    desc:
      "Plan a comfortable journey from Mumbai to Shirdi and other destinations with dependable cabs and courteous drivers.",
    link: "/Mumbai-Outstation-Cabs",
  },
{
  title: "Shani Shingnapur",
  image: "/images/network/shani-shingnapur.png",
  icon: <FaMapMarkedAlt />,
  desc:
    "Visit the sacred Shani Shingnapur temple from Shirdi with a convenient cab, making your spiritual journey peaceful and comfortable.",
  link: "/Shirdi-to-Shani-Shingnapur-Cab",
},
  {
    title: "Aurangabad",
    image: "/images/network/Aurangabaad.png",
    icon: <FaMapMarkedAlt />,
    desc:
      "Explore Aurangabad and nearby heritage attractions with convenient cab service designed for comfortable sightseeing and family travel.",
    link: "/Mumbai-to-Aurangabad-Cab",
  },
{
  title: "Ujjain",
  image: "/images/network/Ujjain.png",
  icon: <FaMapMarkedAlt />,
  desc:
    "Explore Ujjain and nearby spiritual attractions with convenient cab service designed for comfortable sightseeing and family travel.",
  link: "/Mumbai-to-Ujjain-Cab",
},

  {
    title: "Pan India",
    image: "/images/network/pan-india.png",
    icon: <FaGlobeAsia />,
    desc:
      "Reach destinations across India with customized cab arrangements, suitable vehicles and reliable support for long-distance journeys.",
    link: "/Explore-India-Pan-India-Cab-Booking-Services",
  },
];


const Network = () => {
  return (

<>


     <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Our Network
        </h2>
      </div>
    </section>

    <section className="network-section">

      <div className="container">

        

        <div className="row">

          {locations.map((item, index) => (

            <div className="col-lg-4 col-md-6 mb-4" key={index}>

              <div className="network-card">

                <img
                  src={item.image}
                  alt={item.title}
                />

                <div className="network-overlay">

                  <div className="network-icon">

                    {item.icon}

                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.desc}</p>

                  {/* <a href={item.link}>
                    Explore Route
                    <FaArrowRight />
                  </a> */}

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>

</>
  );
};

export default Network;